import React, { useState, useEffect } from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {
  Button,
  CircularProgress
} from '@material-ui/core';
import axios from 'axios';
import querystring from 'querystring';

import utils from '../../../libs/utils';


const Files = (props: RouteComponentProps<{file_id: string}>) => {
  const { file_id } = props.match.params;
  const query = querystring.parse(props.location.search.replace(/^\?/, '')) as {[key: string]: string};
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [fileUrl, setFileUrl] = useState<string>('');
  const [fileName, setFileName] = useState<string>('');

  const loadFile = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      setFileUrl('');
      setFileName('');

      const { data, headers } = await axios.post('/populi/get-raw-file', { fileID: file_id }, {
        responseType: 'blob'
      });

      const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(headers['content-disposition'] || '');
      setFileName(match ? match[1].replace(/['"]/g, '') : '');

      const url = window.URL.createObjectURL(new Blob([data]));
      setFileUrl(url);
    }
    catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
    }
    finally {
      setIsLoading(false);
    }
  };

  const downloadFile = () => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  };

  useEffect(() => {
    (async () => await loadFile())();
  }, []);

  useEffect(() => {
    if (fileUrl && query.download)
      downloadFile();
  }, [fileUrl]);

  if (isLoading)
    return (
      <div className="w-100 h-100 position-fixed d-flex align-items-center justify-content-center">
        <div className="text-center p-5">
          <CircularProgress />
          <p>Loading File</p>
        </div>
      </div>
    );

  if (errorMessage)
    return (
      <div className="w-100 h-100 position-fixed d-flex align-items-center justify-content-center">
        <div className="text-center p-5">
          <h4>Unable to load the file</h4>
          <p className="mb-3">{errorMessage}</p>
          <Button
            type="button"
            variant="outlined"
            size="small"
            color="primary"
            onClick={() => loadFile()}>
            Try Again
          </Button>
        </div>
      </div>
    );

  return (
    <div className="w-100 h-100 position-fixed d-flex align-items-center justify-content-center">
      <div className="text-center p-5">
        <h5>{fileName || 'File was successfully loaded'}</h5>
        <a href={fileUrl}>{fileUrl}</a>

        <hr />

        <Button
          type="button"
          component='a'
          variant="outlined"
          size="small"
          color="primary"
          href={fileUrl}>
          Open File
        </Button>

        <span className="mx-3">|</span>

        <Button
          type="button"
          variant="outlined"
          size="small"
          color="primary"
          onClick={() => downloadFile()}>
          Download File
        </Button>
      </div>
    </div>
  );
};

export default Files;
